module.exports = __webpack_public_path__ + "static/media/in-call.15a23522.gif";